async function updateCartDrawer() {
  const res = await fetch("/?section_id=c-cart-drawer");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;
  const newBox = html.querySelector(".u_cart_drawer").innerHTML;
  document.querySelector(".u_cart_drawer").innerHTML = newBox;
}
$(document).ready(function () {

    $(document).on('click','.u_cart_icon,.u_mb_nav_cart_icon',function (e) {
      e.preventDefault();
    $(".u_cart_drawer_block").addClass("u_cart_drawer_active");
    $("html").addClass("u_cart_overflow");
  });
    $(document).on('click','.u_drawer_overlay,.u_cart_drawer_close',function () {
    $(".u_cart_drawer_block").removeClass("u_cart_drawer_active");
    $("html").removeClass("u_cart_overflow");
  });
   function getCartCount() {
    $.getJSON('/cart.js', function(cart){ 
      var result = cart.item_count;
      console.log(result);     
        $('.u_nav_cart_count').text(result);
      });
    }
    $(document).ready(function(){
      getCartCount();
    });
    
  $(document).on("click", ".u_cart_item_plus", function () {
    console.log("testing");
    let input = $(this).parent().find(".u_qty_number");
    var oldVal = $(this).parent().find(".u_qty_number").val();
    var newVal = parseInt(oldVal) + 1;
    var vid = $(this).attr("data-variantid");
    let cart_count = 0;
    $.getJSON("/cart.js", function (cart) {
      cart_count = parseInt(cart.item_count);
      console.log("cart count before", cart_count);
    });
    let ths = $(this);
    $.ajax({
      url: "/cart/change.js",
      type: "post",
      dataType: "json",
      data: {
        quantity: newVal,
        id: vid,
      },
      beforeSend: function () {
        ths.addClass("custom----disabled");
        ths.closest(".u_cart_item_row").attr("style", "opacity:.3");
        ths.closest(".u_cart_item").find(".u_cart_spinner").show();
      },
      success: function (__cart) {
        console.log("ajax request", __cart);
        let check_count = parseInt(__cart.item_count);
        updateCartDrawer();
           getCartCount();
        if (cart_count == check_count) {
          console.log(`All quantities are in your cart.`);
        } else {
          updateCartDrawer();
             getCartCount();
        }
      },
      complete: function () {
        setTimeout(function () {
          ths.removeClass("custom----disabled");
          ths.closest(".u_cart_item_row").attr("style", "opacity:1");
          ths.closest(".u_cart_item").find(".u_cart_spinner").hide();
        }, 1000);
      },
    });
  });
  $(document).on("click", ".u_cart_item_minus", function () {
    console.log("decrease");
    let input = $(this).parent().find(".u_qty_number");
    let input_val = parseInt(input.val());
    let count = parseInt(input.val()) - 1;
    var vid = $(this).attr("data-variantid");
    let ths = $(this);
    $.ajax({
      url: "/cart/change.js",
      type: "post",
      dataType: "json",
      data: {
        quantity: count,
        id: vid,
      },
      beforeSend: function () {
        ths.addClass("custom----disabled");
        ths.closest(".u_cart_item_row").attr("style", "opacity:.3");
        ths.closest(".u_cart_item").find(".u_cart_spinner").show();
      },
      success: function (__cart) {
        updateCartDrawer();
           getCartCount();
      },
      complete: function () {
        setTimeout(function () {
          ths.removeClass("custom----disabled");
          ths.closest(".u_cart_item_row").attr("style", "opacity:1");
          ths.closest(".u_cart_item").find(".u_cart_spinner").hide();
        }, 1000);
      },
    });
  });
  $(document).on("click", ".u_cart_item_remove svg", function () {
    console.log("remove");
    var vid = $(this).parent().attr("data-variantid");
    let ths = $(this);
    $.ajax({
      url: "/cart/change.js",
      type: "post",
      dataType: "json",
      data: {
        quantity: 0,
        id: vid,
      },
      beforeSend: function () {
        ths.addClass("custom----disabled");
        ths.closest(".u_cart_item_row").attr("style", "opacity:.3");
        ths.closest(".u_cart_item").find(".u_cart_spinner").show();
      },
      success: function (__cart) {
        console.log("cart", __cart);
        updateCartDrawer();
           getCartCount();
      },
      complete: function () {
        setTimeout(function () {
          ths.removeClass("custom----disabled");
          ths.closest(".u_cart_item_row").attr("style", "opacity:1");
          ths.closest(".u_cart_item").find(".u_cart_spinner").hide();
        }, 1000);
      },
    });
  });

  $(".product-form__submit").click(function (e) {
    e.stopPropagation();
    e.preventDefault();
    let form_data = $(this).closest("form").serialize();
    console.log("form data", form_data);
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: form_data,
      dataType: "json",
      beforeSend: function () {
        // setting a timeout
        console.log("before enter");
        $(".u_animated_cont").show();
           $("html").addClass("u_cart_overflow");
      },
      success: function (result) {
        console.log("add to cart");
        updateCartDrawer();
       $(".u_cart_drawer_block").addClass("u_cart_drawer_active");
    $("html").addClass("u_cart_overflow");
         setTimeout(function(){
        getCartCount();                   
      }, 1000);
      },
      error: function (err) {
        console.log("error", err);
      },
      complete: function () {
        console.log("complete");
      },
    });
  });
      $(document).on('click','.u_addon_pro_btn_size',function(){
     let variant_id = $(this).attr('var_id').trim()
     $.ajax({
        type:'POST',
        url:'/cart/add.js',
         data : {
        "id": variant_id,
        "quantity": 1,        
      },
 dataType: 'json',
        success: function(result){
        console.log('add to cart');
console.log("add to cart");
        updateCartDrawer();
       $(".u_cart_drawer_block").addClass("u_cart_drawer_active");
    $("html").addClass("u_cart_overflow");
         setTimeout(function(){
        getCartCount();                   
      }, 1000);
      },
             error: function(err) {
               console.log('error',err)
      },
         complete: function() {
                      console.log('complete');
      }
    })
    })
   $(document).on("click",".u_uppsell_cart_atc_btn",function (e) {
    e.stopPropagation();
    e.preventDefault();
    let form_data = $(this).closest("form").serialize();
    console.log("form data", form_data);
         let ths = $(this);
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: form_data,
      dataType: "json",
      beforeSend: function () {
        // setting a timeout
        console.log("before enter");
     ths.addClass("custom----disabled");
        ths.closest(".u_cart_upsells_block_row").attr("style", "opacity:.3");
        ths.closest(".u_cart_upsells_block").find(".u_cart_spinner").show();
      },
      success: function (result) {
        console.log("add to cart");
         updateCartDrawer();
             setTimeout(function(){
        getCartCount();                   
      }, 1000);
      },
      error: function (err) {
        console.log("error", err);
      },
      complete: function () {
              setTimeout(function () {
          ths.removeClass("custom----disabled");
          ths.closest(".u_cart_upsells_block_row").attr("style", "opacity:1");
          ths.closest(".u_cart_upsells_block").find(".u_cart_spinner").hide();
        }, 1000);
      },
    });
  });
  $(document).on('click','.u_cart_drawer_sale_note_wrapper',function(){
   $('.u_cart_drawer_note_wrapper').toggle() 
    $('.u_cart_drawer_note_icon').toggleClass('active')
  })
});
